// @ts-nocheck
import { useState } from 'react';
import { IconSearch, IconPlus, IconMail, IconPhone, IconBuilding, IconMapPin } from '@tabler/icons-react';
import { Avatar, Badge, Box, Button, Card, Group, Select, SimpleGrid, Stack, Text, TextInput, Title } from '@/components/ui';
import { mockUsers } from '../../mockData';

export default function DirectoryPage() {
  const [search, setSearch] = useState('');
  const [departmentFilter, setDepartmentFilter] = useState<string | null>(null);

  const departments = [...new Set(mockUsers.map(u => u.department))];

  const filteredEmployees = mockUsers.filter(employee => {
    const matchesSearch = employee.name.toLowerCase().includes(search.toLowerCase()) ||
                          employee.email.toLowerCase().includes(search.toLowerCase()) ||
                          employee.title.toLowerCase().includes(search.toLowerCase());
    const matchesDepartment = !departmentFilter || employee.department === departmentFilter;
    return matchesSearch && matchesDepartment;
  });

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'active': return 'green';
      case 'away': return 'yellow';
      case 'busy': return 'red';
      case 'offline': return 'gray';
      default: return 'gray';
    }
  };

  return (
    <Stack gap="lg">
      {/* Header */}
      <Group justify="space-between">
        <Box>
          <Title order={2}>Employee Directory</Title>
          <Text c="dimmed" size="sm">{filteredEmployees.length} employees</Text>
        </Box>
        <Button leftSection={<IconPlus size={16} />}>Add Employee</Button>
      </Group>

      {/* Filters */}
      <Card>
        <Group>
          <TextInput
            placeholder="Search employees..."
            leftSection={<IconSearch size={16} />}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ flex: 1 }}
          />
          <Select
            placeholder="Department"
            data={departments.map(d => ({ value: d, label: d }))}
            value={departmentFilter}
            onChange={setDepartmentFilter}
            clearable
            w={200}
          />
        </Group>
      </Card>

      {/* Employees Grid */}
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }}>
        {filteredEmployees.map(employee => (
          <Card key={employee.id}>
            <Stack gap="md">
              <Group justify="space-between">
                <Group gap="sm">
                  <Avatar size="lg" radius="xl" color="blue" src={employee.avatar}>
                    {employee.name.split(' ').map(n => n[0]).join('')}
                  </Avatar>
                  <Box>
                    <Text fw={600}>{employee.name}</Text>
                    <Text size="sm" c="dimmed">{employee.title}</Text>
                  </Box>
                </Group>
                <Badge size="xs" color={getStatusColor(employee.status)} variant="dot">
                  {employee.status}
                </Badge>
              </Group>

              <Stack gap={4}>
                <Group gap="xs">
                  <IconBuilding size={14} color="var(--mantine-color-dimmed)" />
                  <Text size="sm">{employee.department}</Text>
                </Group>
                <Group gap="xs">
                  <IconMail size={14} color="var(--mantine-color-dimmed)" />
                  <Text size="sm">{employee.email}</Text>
                </Group>
                {employee.phone && (
                  <Group gap="xs">
                    <IconPhone size={14} color="var(--mantine-color-dimmed)" />
                    <Text size="sm">{employee.phone}</Text>
                  </Group>
                )}
                {employee.location && (
                  <Group gap="xs">
                    <IconMapPin size={14} color="var(--mantine-color-dimmed)" />
                    <Text size="sm">{employee.location}</Text>
                  </Group>
                )}
              </Stack>

              <Group justify="space-between">
                <Group gap="xs">
                  {employee.skills?.slice(0, 2).map(skill => (
                    <Badge key={skill} size="xs" variant="light">{skill}</Badge>
                  ))}
                  {employee.skills && employee.skills.length > 2 && (
                    <Badge size="xs" variant="light" color="gray">+{employee.skills.length - 2}</Badge>
                  )}
                </Group>
                <Button variant="light" size="xs">View Profile</Button>
              </Group>
            </Stack>
          </Card>
        ))}
      </SimpleGrid>
    </Stack>
  );
}
